import ContactUs from 'components/Page/ContactUs/ContactUs';

export default ContactUs;
